var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTagLoader = function SvgTagLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.333,
    cy: 13.833,
    r: 0.833,
    fill: "#E7E7E7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 15.999,
    r: 1,
    fill: "#CECECE"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.169,
    cy: 15.333,
    r: 1.167,
    fill: "#BEBEBE"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.333,
    cy: 11.833,
    r: 1.333,
    fill: "#9A9A9A"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.333,
    cy: 7.5,
    r: 1.333,
    fill: "#8E8E8E"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.166,
    cy: 4.167,
    r: 1.5,
    fill: "#757575"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 3.5,
    r: 1.5,
    fill: "#595959"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.333,
    cy: 5.667,
    r: 1.667,
    fill: "#515151"
  })));
};
export default SvgTagLoader;